import { Grid } from "../../../../../../components";
import "./footer-totalizadores-detalhado.scss";

export default function FooterTotalizadoresContadorCfop({ totalizadores }) {
  function formatarChaveCfop(key) {
    if (key.startsWith("totalCfop")) {
      return key.slice(9);
    }
    if (key.endsWith("SemCfop")) {
      return "SEM CFOP";
    }
    return key;
  }
  return (
    <Grid container spacing={2} className="d-flex justify-content-end">
      <Grid item xs={6}>
        <footer className="footer-relatorios">
          <table className="table table-borderless table-sm">
            <thead className="table-primary">
              <tr>
                <th colSpan={2} className="p-2">
                  Totalizador - Por CFOP
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="footer-legenda-bold">CFOP</td>
                <td width="40" className="footer-valor-bold">
                  Valor
                </td>
              </tr>
              {Object.entries(totalizadores).map(([key, value], index) => {
                return (
                  <tr key={`totalizador-${index}`}>
                    <td
                      className={
                        index + 1 === totalizadores.length
                          ? "footer-legenda-bold"
                          : "footer-legenda"
                      }
                    >
                      {formatarChaveCfop(key)}
                    </td>
                    <td
                      width="40"
                      className={
                        index + 1 === totalizadores.length
                          ? "footer-valor-bold"
                          : "footer-valor"
                      }
                    >
                      {value.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </footer>
      </Grid>
    </Grid>
  );
}
